import { render, staticRenderFns } from "./UserGenderBreakdownSection.vue?vue&type=template&id=804f8dde&"
import script from "./UserGenderBreakdownSection.vue?vue&type=script&lang=js&"
export * from "./UserGenderBreakdownSection.vue?vue&type=script&lang=js&"
import style0 from "./UserGenderBreakdownSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports